export const labels = [
  "No poverty",
  "Zero hunger",
  "Good Health and Well-being",
  "Quality Education",
  "Gender Equality",
  "Clean Water and Sanitation",
  "Affordable and Clean Energy",
  "Decent Work and Economy Growth",
  "Industry, Innovation, and Infrastructure",
  "Reduced Inequalities",
  "Sustainable cities and communities",
  "Responsible Consumption and Production",
  "Climate Action",
  "Life Below Water",
  "Life on Land",
  "Peace, Justice and Strong Institutions",
  "Partnerships",
];
export const colors = [
  "#EB1C2D",
  "#D2A12A",
  "#279B48",
  "#C32136",
  "#EF4128",
  "#06ADD9",
  "#FEB614",
  "#8F1838",
  "#F36E29",
  "#E11284",
  "#F99E29",
  "#CF8E2A",
  "#3F7E45",
  "#1C97D3",
  "#59BA47",
  "#136A9F",
  "#14496B",
];
